import { Button, Divider, message } from "antd";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../store/reduxHooks";
import { useReattachToManagerMutation } from "../../../../store/api/listManager.api";
import { useDetachPersonFromManager } from "../../../../utils/Hooks/adminManagerInfo/useDetachPersonFromManager";
import { useGetReattachAvaiableManagerList } from "../../../../utils/Hooks/adminManagerInfo/useGetReattachAvaiableManagerList";
import { detachPersonFromManager } from "../../../../store/slice/adminManagerSlice/adminManagerSlice";
import { AttachPersonToManagerCard } from "../../../Ui/AdminManagerInfo/AttachPersonToManagerCard/AttachPersonToManagerCard";
import { getFullName } from "../../../../utils/utilities/getFullNameStringFromObject";
import { getAttachManagerInnStringInfo } from "../../../../utils/utilities/adminManagerInfo/getAttachManagerInnStringInfo";
import { getAttachManagerFixDate } from "../../../../utils/utilities/adminManagerInfo/getAttachManagerFixDate";
import { ChangeResponsibleManagerModal } from "../ChangeResponsibleManagerModal/ChangeResponsibleManagerModal";

import classes from "./AttachPersonList.module.css";

export const AttachPersonManagerList = () => {
  const dispatch = useDispatch();
  const [openModal, setModalOpen] = useState(false);
  const reattachToManagerId = useRef<null | number>(null);
  const reattachPersonId = useRef<null | number>(null);
  const reattachPersonType = useRef<null | "agent" | "client">(null);
  const currentManagerInfo = useAppSelector(
    (state) => state.adminManagerInfoSlice.currentManager,
  );

  const [reattachPersonTrigger, { isLoading: reattachLoading }] =
    useReattachToManagerMutation();

  const { onDetachPersonFromManager, fetchingDetachMapPersons } =
    useDetachPersonFromManager();

  const managerListWithoutNewManager = useGetReattachAvaiableManagerList(
    currentManagerInfo?.id,
  );

  const handleOkReattachModal = async () => {
    if (typeof reattachToManagerId.current === "number") {
      if (
        currentManagerInfo &&
        reattachPersonId.current &&
        reattachPersonType.current
      ) {
        try {
          await reattachPersonTrigger({
            fromManagerId: currentManagerInfo.id,
            toManagerId: reattachToManagerId.current,
            humanIds: [reattachPersonId.current],
            type: reattachPersonType.current,
          }).unwrap();

          dispatch(
            detachPersonFromManager({
              personType: reattachPersonType.current,
              personId: reattachPersonId.current,
            }),
          );

          setModalOpen(false);

          message.success("Менеджер успешно переприкреплен");
        } catch {
          message.error("Произошла ошибка");
        }
      }
    } else {
      message.error("Выберите ответсвенного менеджера");
    }
  };

  const handleDetachPersonFromManager =
    (personId: number, personType: "agent" | "client") => async () => {
      if (currentManagerInfo) {
        await onDetachPersonFromManager(currentManagerInfo.id, personId);
        dispatch(detachPersonFromManager({ personId, personType }));
        message.success("Пользователь успешно откреплен");
      }
    };

  const onClickChangeResponsible =
    (personId: number, personType: "client" | "agent") => () => {
      setModalOpen(true);
      reattachPersonId.current = personId;
      reattachPersonType.current = personType;
    };

  return (
    <>
      {currentManagerInfo?.agents?.length !== undefined &&
        currentManagerInfo?.agents?.length > 0 && (
          <>
            <Divider
              className={classes.divider}
              orientationMargin={0}
              orientation="left"
            >
              Список агентов
            </Divider>
            {currentManagerInfo?.agents.map((el) => {
              return (
                <div key={el.id} className={classes.personItem}>
                  <AttachPersonToManagerCard
                    fullName={getFullName(el)}
                    inn={getAttachManagerInnStringInfo(el)}
                    fixDate={getAttachManagerFixDate(el.connect_data)}
                    deleteButtonProps={{
                      onClick: handleDetachPersonFromManager(el.id, "agent"),
                    }}
                    loadingDelete={
                      fetchingDetachMapPersons[el.id] ? true : false
                    }
                  />

                  <Button
                    className={classes.changeResponsibleBtn}
                    color="primary"
                    variant="outlined"
                    size="large"
                    onClick={onClickChangeResponsible(el.id, "agent")}
                  >
                    Поменять ответственного
                  </Button>
                </div>
              );
            })}
          </>
        )}

      {currentManagerInfo?.clients?.length !== undefined &&
        currentManagerInfo?.clients?.length > 0 && (
          <>
            <Divider
              orientationMargin={0}
              className={classes.divider}
              orientation="left"
            >
              Список клиентов
            </Divider>
            {currentManagerInfo?.clients.map((el) => {
              return (
                <div key={el.id} className={classes.personItem}>
                  <AttachPersonToManagerCard
                    fullName={el?.organization?.name}
                    inn={getAttachManagerInnStringInfo(el)}
                    fixDate={getAttachManagerFixDate(el.connect_data)}
                    deleteButtonProps={{
                      onClick: handleDetachPersonFromManager(el.id, "client"),
                    }}
                    loadingDelete={
                      fetchingDetachMapPersons[el.id] ? true : false
                    }
                  />

                  <Button
                    className={classes.changeResponsibleBtn}
                    color="primary"
                    variant="outlined"
                    size="large"
                    onClick={onClickChangeResponsible(el.id, "client")}
                  >
                    Поменять ответственного
                  </Button>
                </div>
              );
            })}
          </>
        )}

      {currentManagerInfo && (
        <ChangeResponsibleManagerModal
          open={openModal}
          managerList={managerListWithoutNewManager}
          onChangeActiveManagerId={(value) => {
            reattachToManagerId.current = value;
          }}
          onOk={handleOkReattachModal}
          okButtonProps={{
            loading: reattachLoading,
            disabled: reattachLoading,
          }}
          onCancel={() => {
            setModalOpen(false);
          }}
        />
      )}
    </>
  );
};
